export default __webpack_public_path__ + "static/media/gps.1d71fff7.svg";